module.exports = __webpack_public_path__ + "static/media/course_02.e3e49147.jpg";